export function getFormUrl(name: string): string {
  const formUrls: Record<string, string> = {
    '联系表单': 'https://readdy.ai/api/form/d9s992nnahb7382ovsg0',
  };
  return formUrls[name] || '';
}